import { render, staticRenderFns } from "./SOItemReport.vue?vue&type=template&id=1a1d5b03&"
import script from "./SOItemReport.vue?vue&type=script&lang=js&"
export * from "./SOItemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports